export default {
    add_card: 'បន្ថែមកាត',
    set_default: 'សំណុំ លំនាំដើម',
    card_debit: 'កាតឥណទាន/ឥណពន្ធ',
    type: 'ប្រភេទ',
    confirm_set_default_text:
        'តើអ្នកប្រាកដទេថាចង់កំណត់ការទូទាត់លំនាំដើមសម្រាប់កាតនេះ?',
    payment_card_delete_confirm: 'តើអ្នកប្រាកដទេថាចង់លុបកាតរបស់អ្នក?',
    payment_type_text: 'តើអ្នកប្រាកដទេថាចង់កំណត់វិធីនេះសម្រាប់ការទូទាត់?',
    auto_renew_priority_method: 'វិធីសាស្រ្តអាទិភាពបន្តដោយស្វ័យប្រវត្តិ',
    default: 'លំនាំដើម',
    add_new_card: 'បន្ថែមកាតថ្មី',
    agree: 'ខ្ញុំយល់ព្រមនឹង',
    term_conditions: 'លក្ខខណ្ឌទាំងអស់',
    add_new_card_hint: {
        KH: 'វិធីសាស្រ្តនេះត្រូវបានគ្រប់គ្រងដោយ ABA ដើម្បីរក្សាទុកព័ត៌មានកាតរបស់អ្នកយ៉ាងមានសុវត្ថិភាពសម្រាប់ការបង់ប្រាក់លើកក្រោយ',
        AE: 'វិធីសាស្រ្តនេះត្រូវបានគ្រប់គ្រងដោយ STRIPE ដើម្បីរក្សាទុកព័ត៌មានកាតរបស់អ្នកយ៉ាងមានសុវត្ថិភាពសម្រាប់ការបង់ប្រាក់លើកក្រោយ',
        TH: 'វិធីសាស្រ្តនេះត្រូវបានគ្រប់គ្រងដោយ OMISE ដើម្បីរក្សាទុកព័ត៌មានកាតរបស់អ្នកយ៉ាងមានសុវត្ថិភាពសម្រាប់ការបង់ប្រាក់លើកក្រោយ',
    },
    accepted_payments: 'យើង​ទទួល',
    settings: 'ការកំណត់',
    card_name: 'Card name',
    card_number: 'លេខ កាត',
    card_expiry: 'កាតផុតកំណត់',
    card_cvc: 'កាត CVC',
    card_cvc_hint:
        'លេខកូដនេះគឺជាលេខបី ឬបួនខ្ទង់ដែលបោះពុម្ពនៅខាងក្រោយ ឬខាងមុខកាតឥណទាន។',
    card_maintenance_message:
        'ការទូទាត់កើតឡើងដដែលៗនៃប័ណ្ណឥណពន្ធ/ឥណពន្ធគឺស្ថិតនៅក្រោមការថែទាំ ហើយយើងនឹងត្រលប់មកអ្នកវិញក្នុងពេលឆាប់ៗនេះ។',
    pay_invoice: 'បង់វិក្កយបត្រ',
    payment_method: 'វិធី​សា​ស្រ្ត​ទូទាត់',
    payway_cards: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    omise_cards: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    stripe_cards: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    stripe_method: {
        name: 'Visa/ Mastercard',
        slogan: 'Visa, Mastercard',
    },
    please_add_new_card: 'សូមបញ្ចូលកាតថ្មីដើម្បីទូទាត់!',
    aba_mobile: 'ABA Mobile - {fee}',
    aba_mobile_fee: '0% Fee',
    aba_mobile_detail: 'ស្កេនដើម្បីទូទាត់ប្រាក់ជាមួយ ABA Mobile',
    union_pay: {
        name: 'UnionPay',
    },
    wire_banking_transfer: 'ផ្ទេរប្រាក់តាមធនាគារ',
    validate_minutes: 'សុពលភាពក្នុងរយៈពេល ៣០ នាទី',
    your_account_balance: 'តុល្យភាព គណនីរបល់អ្នក',
    use_to_pay: 'ប្រើប្រាស់ {balance} ដើម្បីបង់',
    not_enough_to_pay: {
        1: 'មិនគ្រប់គ្រាន់ក្នុងការបង់ប្រាក់',
        2: 'បញ្ចូលទឹកប្រាក់',
        3: 'ឥឡូវ​នេះ',
    },
    your_promo_credit: 'ឥណទានផ្សព្វផ្សាយរបស់អ្នក',
    promo_credit_voucher_warning:
        'ការជ្រើសរើសប័ណ្ណបញ្ចុះតម្លៃនឹងមិនអនុញ្ញាតឱ្យអ្នក ប្រើប្រាស់កាតឥណទានក្នុងការទូទាត់នោះទេ',
    payment_success: 'ការទូទាត់ទទួលបានជោគជ័យ!',
    payment_pending: 'ការទូទាត់កំពុងរង់ចាំ',
    thank_you: 'អរគុណ',
    banking_transfer_warning:
        'សូមចម្លងការបរិយាយផ្ទេរប្រាក់ខាងលើអោយបានត្រឹមត្រូវពេលអ្នកផ្ទេប្រាក់មកយើងខ្ញុំ ',
    update_information: 'សូមធ្វើបច្ចុប្បន្នភាពព័ត៌មានរបស់អ្នកដើម្បីបន្ត',
    choose_payment_options: 'ជ្រើសរើសជម្រើសទូទាត់',
    stripe_allows_payment_hint:
        'Stripe អនុញ្ញាតតែការទូទាត់ដោយចាប់ផ្តើមពី {minPrice} សូមប្រើសមតុល្យកាបូបរបស់អ្នកឬ',
    top_up_alert:
        'Please top-up credit to your account, payment gateway accepts a minimum of {amount}.',
    checkout: 'ពិនិត្យមុនចេញ',
    top_up_now: 'បញ្ហាញទឹកប្រាក់ភ្លាម',
    payment_success_description_message: {
        info: 'អ្នកទើបតែបានធ្វើការបញ្ជាទិញដោយជោគជ័យនូវ {invoiceId} សម្រាប់ {total}។',
        hint: 'អ្នកអាចមើលព័ត៌មានលម្អិតរបស់វិក្កយបត្រដោយធ្វើការចុចប៊ូតុងខាងក្រោម។',
    },
    transaction_id_with_value: 'Transaction ID: {transactionId}',
    modal_limit_amount: {
        main_title: 'លើសចំនួនកំណត់',
        description: 'សូមជ្រើសរើសសេវាកម្មក្រោម {amount} ដើម្បីបន្ត',
    },
};
